import clsx from "clsx";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Api } from "@/api";
import Breadcrumbs from "~/components/common/breadcrumbs";
import Button from "~/components/common/button";
import Icon from "~/components/common/icon";
import ClientComments from "~/components/pages/sectionNew/clientComments";
import FilterBlock from "~/components/pages/sectionNew/filterBlock";
import { showPopup } from "~/redux/action-creaters/popup";
import { declOfNum } from "~/utils";

import { fetchAllReviewsAndQuestions } from "../../../../redux/action-creaters/section";
import { popupTypes } from "../../../../redux/reducers/popupReducer";
import Pagen from "../../../common/pagen";
import Banner from "../banner";
import Product from "../product";
import styles from "./index.module.scss";

const ManagerInstallPrice = dynamic(
  () => import("~/components/pages/section/manager/installPrice"),
  {
    ssr: false,
    loading: () => null,
  },
);

const MetaManagerComments = dynamic(
  () => import("~/components/pages/sectionNew/metaManagerComments"),
  {
    ssr: false,
    loading: () => null,
  },
);

export default function SectionNewBody({ section = {} }: any) {
  const { products, count, params, meta } = useSelector(
    (state: any) => state.section,
  );
  const { cityName, deliveyCity } = useSelector((state: any) => state.location);

  const [isShowMobileFilter] = useState(false);
  const { contactsData } = useSelector((state: any) => state.contacts);
  const { edostMinDays } = useSelector((state: any) => state.location);
  const { user } = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  const [deliveryProductInfo, setDeliveryProductInfo]: any = useState({});
  const [managerInstall, setManagerInstall] = useState([]);
  const [managerData, setManagerData] = useState([]);
  const [managerComments, setManagerComments] = useState([]);
  const { host } = useSelector((state: any) => state.params);

  useEffect(() => {
    if (cityName && edostMinDays) {
      if (contactsData.NAME === "Центральный") {
        const deliveryProductInfo: any = {};
        products.forEach((product: any) => {
          if (product.CATALOG.AVAILABLE) {
            deliveryProductInfo[product.ID] =
              `Доставка в г. ${cityName} от ${declOfNum(edostMinDays, ["дня", "дней", "дней"])}`;
          } else {
            // deliveryProductInfo[product.ID] = 'Нет в наличии'
          }
        });
        setDeliveryProductInfo(deliveryProductInfo);
      } else {
        setDeliveryProductInfo({});
      }
    }
  }, [cityName, edostMinDays, contactsData, products]);

  useEffect(() => {
    const body: any = document.querySelector("body");
    if (!isShowMobileFilter) {
      body.classList.remove("popup");
    } else {
      body.classList.add("popup");
    }
  }, [isShowMobileFilter]);

  const router = useRouter();
  useEffect(() => {
    if (user.IS_MANAGER || user.IS_ADMIN || Boolean(router.query.demo)) {
      const ids = products.map((item: any) => item.ID);
      const getComments = async () => {
        setManagerComments(await Api.catalog.getManagerComments(ids));
      };
      const getManagerInstall = async () => {
        setManagerInstall(await Api.catalog.getManagerInstall(ids));
      };
      const getData = async () => {
        setManagerData(
          await Api.server.getManagerDelivery(
            ids,
            // @ts-ignore
            router.query.time,
            router.query.weekday,
          ),
        );
      };
      getComments();
      getData();
      getManagerInstall();
    }
  }, [user, products]);

  const { sections } = useSelector((state: any) => state.sections);

  useEffect(() => {
    // @ts-ignore
    (window as any).dataLayer = window.dataLayer || [];
    // @ts-ignore
    (dataLayer as any).push({
      ecommerce: {
        currencyCode: "RUB",
        impressions: products.map((product: any) => {
          return {
            id: product.ID,
            name: product.NAME,
            price: product.CATALOG?.MIN_PRICE,
            category: sections[product.IBLOCK_SECTION_ID].NAME,
            brand: product.BRAND?.name,
            list: "Каталог",
          };
        }),
      },
    });
  }, []);

  const [viewType, setViewType] = useState(0);

  useEffect(() => {
    dispatch(
      fetchAllReviewsAndQuestions(
        window.location.host.includes("localhost")
          ? "msk"
          : window.location.host.split(".")[0],
        products.map((item: any) => item.ID),
        Boolean(router.query.reset),
      ),
    );
  }, [products]);

  useEffect(() => {
    if (products.length === 0) {
      Api.server.addLogError(window.location.href, "errorsEmptyCatalog");
    }
  }, [products]);

  // @ts-ignore
  return (
    <div className="container">
      <Breadcrumbs />

      <h1 className={styles.h1}>
        <span>{meta.h1 ?? section.NAME}</span>
        {host.replace("farkop-msk", "farkop") !== "farkop.ru" && (
          <span className={styles.h1City}>в {meta.titleCity}</span>
        )}
      </h1>
      <Banner cityName={deliveyCity} sectionId={section.ID} />
      <div className={styles.Content}>
        <div className={styles.Top}>
          <FilterBlock section={section} productCount={products.length} />

          {section.ID === "635" &&
            cityName &&
            !["Москва", "Санкт-Петербург"].includes(cityName) && (
              <div className={styles.TopBanner}>
                {cityName !== "Россия" && (
                  <span>
                    Быстрая доставка товаров в г.{cityName} проверенными
                    транспортными компаниями
                  </span>
                )}
                {cityName === "Россия" && (
                  <span>
                    Доставку осуществляем по всей территории России
                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                    <div className={styles.SelectCity}>
                      <Button
                        onClick={() =>
                          dispatch(showPopup(popupTypes.locationNew))
                        }
                        label="Выберите город"
                      />
                    </div>
                  </span>
                )}
              </div>
            )}
        </div>
        {section.ID === "635" && (user.IS_MANAGER || user.IS_ADMIN) && (
          <ManagerInstallPrice />
        )}
        <div className={styles.Block}>
          {(user.IS_MANAGER || user.IS_ADMIN) && <MetaManagerComments />}
          <ClientComments />
          <div className={styles.View}>
            <div>
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
              <span
                className={clsx(viewType === 0 && styles.Selected)}
                onClick={() => {
                  setViewType(0);
                }}
              >
                <Icon id="list" size={13} fill="#000" />
              </span>
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
              <span
                className={clsx(viewType === 1 && styles.Selected)}
                onClick={() => {
                  setViewType(1);
                  // @ts-ignore
                  if (typeof ym !== "undefined") {
                    // @ts-ignore
                    ym(20518312, "reachGoal", "changeCatalogViewToTable");
                  }
                }}
              >
                <Icon id="table" size={13} fill="#000" />
              </span>
            </div>
          </div>
          <div
            id="catalog"
            className={clsx(
              styles.Products,
              viewType === 1 && styles.ProductsTable,
            )}
          >
            {products.map((product: any) => (
              <Product
                viewType={viewType}
                data={product}
                key={product.ID}
                managerData={managerData[product.ID]}
                managerComment={managerComments[product.ID]}
                managerInstall={managerInstall[product.ID]}
              />
            ))}
            {products.length === 0 && (
              <span className={styles.Empty}>
                По заданным фильтрам нет товаров.
              </span>
            )}
          </div>
          <div className={styles.Bottom}>
            <Pagen
              count={count}
              size={params.pageSize}
              currentNum={params.pageNum}
              isShowShowMore
            />
          </div>
          {meta.seoBottom && (
            <div className="text">
              <div
                className={styles.SeoBottom}
                dangerouslySetInnerHTML={{ __html: meta.seoBottom }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
